import useIsSearchPage from '@klaviyo-mkt/gatsby-components/hooks/useIsSearchPage';

import * as styles from './styles/search.module.scss';

import type { Hit } from 'instantsearch.js';
import type { SendEventForHits } from 'instantsearch.js/es/lib/utils/createSendEventForHits';
import type { ICommunityHit } from './types';

const CommunityHit = ({ hit, sendEvent }: { hit: Hit<ICommunityHit>; sendEvent: SendEventForHits; }) => {
  const { url } = hit;
  const {
    _highlightResult: { title } = { title: { value: '' } },
    _snippetResult: { content } = { content: { value: '' } },
  } = hit;

  const showDescription = useIsSearchPage();

  if (url) {
    return (
      <div>
        <a
          className={styles.link}
          dangerouslySetInnerHTML={{ __html: title.value }}
          href={url}
          onClick={sendEvent}
        />
        {showDescription && (
          <div className={styles.snippet}
            dangerouslySetInnerHTML={{ __html: content.value }}
          />
        )}
      </div>
    );
  }

  return <></>;
};

export default CommunityHit;
